import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RaceResultComponent } from './race-result/race-result.component';
import { UpdateRaceEntryResultComponent } from './update-race-entry-result/update-race-entry-result.component';
import { EditRaceEntryComponent } from './edit-race-entry/edit-race-entry.component';
import { AdminRacePredictionComponent } from './admin-race-prediction/admin-race-prediction.component';
import { AdminUpdateUserPredictionComponent } from './admin-update-user-prediction/admin-update-user-prediction.component';

const routes: Routes = [
  {
    path:'raceResult',
    component:RaceResultComponent
  },
  {
    path:'update/raceResult',
    component:UpdateRaceEntryResultComponent
  },
  {
    path:'editRaceEntry',
    component:EditRaceEntryComponent
  },
  {
    path: 'adminRacePrediction',
    component: AdminRacePredictionComponent
  },
  {
    path: 'updateUserPrediction',
    component: AdminUpdateUserPredictionComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class RaceResultRoutingModule { }
